export default `
<html>
  <head>
    <meta content="text/html; charset=UTF-8" http-equiv="content-type" />
    <style type="text/css">
      ol {
        margin: 0;
        padding: 0;
      }
      table td,
      table th {
        padding: 0;
      }
      .c1 {
        padding-top: 0pt;
        padding-bottom: 0pt;
        line-height: 1.15;
        orphans: 2;
        widows: 2;
        text-align: left;
        height: 11pt;
      }
      .c4 {
        color: #000000;
        font-weight: 700;
        text-decoration: none;
        vertical-align: baseline;
        font-size: 11pt;
        font-family: "Arial";
        font-style: normal;
      }
      .c0 {
        color: #000000;
        font-weight: 400;
        text-decoration: none;
        vertical-align: baseline;
        font-size: 11pt;
        font-family: "Arial";
        font-style: normal;
      }
      .c3 {
        padding-top: 0pt;
        padding-bottom: 0pt;
        line-height: 1.15;
        orphans: 2;
        widows: 2;
        text-align: left;
      }
      .c2 {
        background-color: #ffffff;
        max-width: 468pt;
        padding: 72pt 72pt 72pt 72pt;
      }
      .title {
        padding-top: 0pt;
        color: #000000;
        font-size: 26pt;
        padding-bottom: 3pt;
        font-family: "Arial";
        line-height: 1.15;
        page-break-after: avoid;
        orphans: 2;
        widows: 2;
        text-align: left;
      }
      .subtitle {
        padding-top: 0pt;
        color: #666666;
        font-size: 15pt;
        padding-bottom: 16pt;
        font-family: "Arial";
        line-height: 1.15;
        page-break-after: avoid;
        orphans: 2;
        widows: 2;
        text-align: left;
      }
      li {
        color: #000000;
        font-size: 11pt;
        font-family: "Arial";
      }
      p {
        margin: 0;
        color: #000000;
        font-size: 11pt;
        font-family: "Arial";
      }
      h1 {
        padding-top: 20pt;
        color: #000000;
        font-size: 20pt;
        padding-bottom: 6pt;
        font-family: "Arial";
        line-height: 1.15;
        page-break-after: avoid;
        orphans: 2;
        widows: 2;
        text-align: left;
      }
      h2 {
        padding-top: 18pt;
        color: #000000;
        font-size: 16pt;
        padding-bottom: 6pt;
        font-family: "Arial";
        line-height: 1.15;
        page-break-after: avoid;
        orphans: 2;
        widows: 2;
        text-align: left;
      }
      h3 {
        padding-top: 16pt;
        color: #434343;
        font-size: 14pt;
        padding-bottom: 4pt;
        font-family: "Arial";
        line-height: 1.15;
        page-break-after: avoid;
        orphans: 2;
        widows: 2;
        text-align: left;
      }
      h4 {
        padding-top: 14pt;
        color: #666666;
        font-size: 12pt;
        padding-bottom: 4pt;
        font-family: "Arial";
        line-height: 1.15;
        page-break-after: avoid;
        orphans: 2;
        widows: 2;
        text-align: left;
      }
      h5 {
        padding-top: 12pt;
        color: #666666;
        font-size: 11pt;
        padding-bottom: 4pt;
        font-family: "Arial";
        line-height: 1.15;
        page-break-after: avoid;
        orphans: 2;
        widows: 2;
        text-align: left;
      }
      h6 {
        padding-top: 12pt;
        color: #666666;
        font-size: 11pt;
        padding-bottom: 4pt;
        font-family: "Arial";
        line-height: 1.15;
        page-break-after: avoid;
        font-style: italic;
        orphans: 2;
        widows: 2;
        text-align: left;
      }
    </style>
  </head>
  <body class="c2 doc-content">
    <h3 class="c3">
      <span class="c4">THIS TICKET IS A REVOCABLE LICENSE;</span>
    </h3>
    <h3 class="c3">
      <span class="c4">USER ACCEPTS RISK OF ILLNESS/INJURY; NO RE-ENTRY </span>
    </h3>
    <div class="c1"><span class="c0"></span></div>
    <p class="c3">
      <span class="c0"
        >By using this ticket, holder, on their behalf and on behalf of any
        minor (&ldquo;Minor&rdquo;) and any accompanying party for whom holder
        retains a ticket to attend the Event (defined below) (each of whom
        holder represents authorized holder to act on their behalf in accepting
        applicable Agreement terms) (with Minor, &ldquo;Accompanying
        Parties&rdquo;), agrees to the terms and conditions, including an
        AGREEMENT TO ARBITRATE/CLASS ACTION WAIVER, at
        [https://www.milb.com/columbia/tickets/ticketback]
        (&ldquo;Agreement&rdquo;) and the Agreement summary below (Agreement
        controls if any conflict). Holder and Accompanying Parties are,
        collectively, &ldquo;Holder&rdquo;.</span
      >
    </p>
    <div class="c1"><span class="c0"></span></div>
    <p class="c3">
      <span class="c0"
        >AN INHERENT RISK OF EXPOSURE TO COVID-19 AND OTHER COMMUNICABLE
        DISEASES EXISTS IN ANY PUBLIC PLACE REGARDLESS OF PRECAUTIONS THAT MAY
        BE TAKEN. HOLDER (1) ASSUMES ALL RISKS ASSOCIATED WITH COVID-19 AND
        OTHER COMMUNICABLE DISEASES, AND (2) WILL COMPLY WITH HEALTH/SAFETY
        POLICIES OF CLUB AND HOST VENUE OWNER/OPERATOR.
      </span>
    </p>
    <div class="c1"><span class="c0"></span></div>
    <p class="c3">
      <span class="c0"
        >Holder will comply with all [Columbia Fireflies] (&ldquo;Club&rdquo;)
        and host venue policies &amp; protocols. &nbsp;Holder will not
        transmit/aid in transmitting photographs, images, videos, audio, live
        streams or other accounts/descriptions (including play-by-play data)
        (whether text, data or visual), in any media, about the game/event or
        related attractions (collectively, &ldquo;Event&rdquo;). Holder consents
        to and waives compensation for use of their image or other personality
        rights and consents to security searches/screening. MLB Entities
        (defined below) reserve the right to revoke this license without refund
        and refuse admission/eject anyone who (a) violates Agreement terms; (b)
        appears to be or is intoxicated; (c) is deemed by an MLB Entity to be
        disorderly or a health/safety risk; or (d) uses vulgar or abusive
        language.
      </span>
    </p>
    <div class="c1"><span class="c0"></span></div>
    <p class="c3">
      <span class="c0"
        >Holder acknowledges/assumes all risks of attending the Event,
        including, without limitation, contracting COVID-19 or other
        communicable disease or being injured by bats, balls or other items.
        Holder releases Club and all other MLB-related entities (&ldquo;MLB
        Entities&rdquo;), host venue, ticket provider, and all successors,
        assigns, players, managers, coaches, employees, partners, members,
        directors, officers, owners, agents, representatives, licensees,
        sponsors, vendors and contractors (collectively,
        &ldquo;Releasees&rdquo;), from claims arising out of the Event, even if
        due to the sole, joint, or comparative negligence, or strict liability,
        of Releasees (&ldquo;Released Claims&rdquo;) and will indemnify
        &nbsp;Releasees from and against Released Claims.</span
      >
    </p>
    <div class="c1"><span class="c0"></span></div>
    <p class="c3">
      <span class="c0"
        >HOLDER IS DEEMED TO HAVE GIVEN A FULL RELEASE OF LIABILITY TO RELEASEES
        TO THE FULLEST EXTENT PERMITTED BY LAW. &nbsp;IF HOLDER CANNOT AGREE FOR
        ACCOMPANYING PARTIES, ACCOMPANYING PARTIES MUST LEAVE THE EVENT.</span
      >
    </p>
    <p class="c3">
      <span class="c0"
        >ANY CLAIM RELATED TO THIS TICKET SHALL BE SETTLED BY MANDATORY,
        CONFIDENTIAL, FINAL, BINDING ARBITRATION. HOLDER MAY NOT JOIN OR
        CONSOLIDATE CLAIMS OR ARBITRATE AS A REPRESENTATIVE MEMBER OF A PUTATIVE
        CLASS OR IN A PRIVATE ATTORNEY GENERAL CAPACITY.</span
      >
    </p>
    <div class="c1"><span class="c0"></span></div>
    <p class="c3">
      <span class="c0"
        >This ticket is valid only for this Event; if not played or completed,
        this ticket will admit Holder to the rescheduled/resumed Event; if not
        rescheduled/resumed, refunds or credits will be as determined in
        Club&rsquo;s discretion.
      </span>
    </p>
    <div class="c1"><span class="c0"></span></div>
    <div class="c3">
      <span class="c0"
        >&copy;2023 MLB Professional Development Leagues, LLC.</span
      >
    </div>
    <div class="c1"><span class="c0"></span></div>
  </body>
</html>

`;
